export default __webpack_public_path__ + "static/media/daily-commuting.f6ca3067.svg";